const resources = {
  en: {
    budgetManager: {
      title: 'Budgets',
      subtitle: 'Track dedicated savings goals and record deposits from the accounts that fund them.',
      filters: {
        status: 'Status',
        summary: 'Showing {{count}} budgets',
        options: {
          open: 'Open',
          closed: 'Closed',
          all: 'All',
        },
      },
      sections: {
        registryTitle: 'Budget list',
        registryDescription: 'Review progress, remaining balance, and funding actions for each budget.',
      },
      metrics: {
        totalBudgets: 'Budgets',
        openBudgets: 'Open budgets',
        closedBudgetsMeta: '{{count}} closed',
        savedTotal: 'Saved total',
        remainingTotal: 'Remaining total',
        mixedCurrenciesValue: 'Mixed',
        mixedCurrenciesMeta: 'Visible budgets use more than one currency',
        currencySummary: '{{currency}} budgets',
        completionRateMeta: 'complete',
      },
      actions: {
        add: 'Add budget',
        edit: 'Edit',
        delete: 'Delete',
        deposit: 'Record deposit',
        save: 'Save',
        cancel: 'Cancel',
        confirmDeleteTitle: 'Delete this budget?',
      },
      table: {
        saved: 'Saved',
      },
      status: {
        open: 'Open',
        closed: 'Closed',
      },
      list: {
        empty: 'No budgets yet',
        targetLabel: 'Target:',
        remainingLabel: 'Remaining:',
      },
      form: {
        editTitle: 'Edit budget',
        addTitle: 'Add budget',
        name: 'Name',
        targetAmount: 'Target amount',
        description: 'Description',
      },
      depositModal: {
        title: 'Deposit to {{budgetName}}',
        fromAccount: 'From account',
        accountPlaceholder: 'Select account',
        amount: 'Amount',
        note: 'Note',
      },
      toasts: {
        loadBudgetsError: 'Failed to load budgets',
        loadBudgetError: 'Failed to load budget details',
        loadAccountsError: 'Failed to load accounts',
        loadDepositsError: 'Failed to load deposits',
        budgetUpdated: 'Budget updated',
        budgetCreated: 'Budget created',
        budgetDeleted: 'Budget deleted',
        depositRecorded: 'Deposit recorded',
        budgetCreateError: 'Failed to create budget',
        budgetUpdateError: 'Failed to update budget',
        budgetDeleteError: 'Failed to delete budget',
        depositError: 'Failed to record deposit',
        actionError: '{{message}}',
      },
    },
  },
  uk: {
    budgetManager: {
      title: 'Бюджети',
      subtitle: 'Відстежуйте окремі цілі накопичення та фіксуйте поповнення з рахунків, які їх фінансують.',
      filters: {
        status: 'Статус',
        summary: 'Показано бюджетів: {{count}}',
        options: {
          open: 'Відкриті',
          closed: 'Закриті',
          all: 'Усі',
        },
      },
      sections: {
        registryTitle: 'Список бюджетів',
        registryDescription: 'Переглядайте прогрес, залишок і дії поповнення для кожного бюджету.',
      },
      metrics: {
        totalBudgets: 'Бюджети',
        openBudgets: 'Відкриті бюджети',
        closedBudgetsMeta: '{{count}} закрито',
        savedTotal: 'Накопичено',
        remainingTotal: 'Залишилось',
        mixedCurrenciesValue: 'Різні валюти',
        mixedCurrenciesMeta: 'У видимих бюджетів різні валюти',
        currencySummary: 'Бюджети в {{currency}}',
        completionRateMeta: 'завершено',
      },
      actions: {
        add: 'Додати бюджет',
        edit: 'Редагувати',
        delete: 'Видалити',
        deposit: 'Зафіксувати поповнення',
        save: 'Зберегти',
        cancel: 'Скасувати',
        confirmDeleteTitle: 'Видалити цей бюджет?',
      },
      table: {
        saved: 'Накопичено',
      },
      status: {
        open: 'Відкритий',
        closed: 'Закритий',
      },
      list: {
        empty: 'Поки немає бюджетів',
        targetLabel: 'Ціль:',
        remainingLabel: 'Залишок:',
      },
      form: {
        editTitle: 'Редагувати бюджет',
        addTitle: 'Додати бюджет',
        name: 'Назва',
        targetAmount: 'Цільова сума',
        description: 'Опис',
      },
      depositModal: {
        title: 'Поповнити {{budgetName}}',
        fromAccount: 'З рахунку',
        accountPlaceholder: 'Оберіть рахунок',
        amount: 'Сума',
        note: 'Нотатка',
      },
      toasts: {
        loadBudgetsError: 'Не вдалося завантажити бюджети',
        loadBudgetError: 'Не вдалося отримати деталі бюджету',
        loadAccountsError: 'Не вдалося завантажити рахунки',
        loadDepositsError: 'Не вдалося завантажити поповнення',
        budgetUpdated: 'Бюджет оновлено',
        budgetCreated: 'Бюджет створено',
        budgetDeleted: 'Бюджет видалено',
        depositRecorded: 'Поповнення зафіксовано',
        budgetCreateError: 'Не вдалося створити бюджет',
        budgetUpdateError: 'Не вдалося оновити бюджет',
        budgetDeleteError: 'Не вдалося видалити бюджет',
        depositError: 'Не вдалося зафіксувати поповнення',
        actionError: '{{message}}',
      },
    },
  },
}

export default resources
